import api from './api';

export const whoisService = {
  /**
   * Update the Whois API token for a ticket
   * @param {number} ticketId - The ticket ID
   * @param {string} token - The API token
   */
  updateToken: async (ticketId, token) => {
    try {
      const response = await api.put(
        `/ticket/updateWhoisToken/${ticketId}`,
        { token }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating whois token:', error);
      throw error;
    }
  },
};
